import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingDairyFeedAdditive, setFootprintingDairyFeedAdditiveAdmin } from "services";

import { footprintingDairyPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_DAIRY_FEED_ADDITIVE } from "consts";

import { FootprintingDairyFeedAdditivePayload } from "models";

export const useMutateFootprintingDairyFeedAdditive = (farmId: string, year: number, payload: FootprintingDairyFeedAdditivePayload, primaryDataId?: string) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  return useMutation(
    {
      mutationKey: [FOOTPRINTING_DAIRY_FEED_ADDITIVE, primaryDataId, isAdmin],
      mutationFn: () => (isAdmin ? setFootprintingDairyFeedAdditiveAdmin(payload, primaryDataId) : setFootprintingDairyFeedAdditive(payload, primaryDataId)),
      onSuccess: async () => {
        invalidateAndRefecthQueries(queryClient, [
          [FOOTPRINTING_DAIRY_FEED_ADDITIVE, primaryDataId, isAdmin],
          ...footprintingDairyPrimaryQueryKeys(primaryDataId ?? "", farmId, year, isAdmin),
        ]);
      },
    },
    queryClient
  );
};
